import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import GalleryService from '@/services/gallery.service';
import AddArtworkForm from '@/shared-components/forms/add-artwork';
import Loader from '@/shared-components/loader/Loader';

export default function EditArtwork() {
  const location = useLocation();
  const seededArtwork = location.state?.artworkData ?? null;
  const artworkSlug = seededArtwork?.slug ?? null;
  const [artworkData, setArtworkData] = useState(null);
  const [loading, setLoading] = useState(Boolean(artworkSlug));

  useEffect(() => {
    let isMounted = true;

    async function loadArtwork() {
      if (!artworkSlug) {
        setArtworkData(seededArtwork);
        setLoading(false);
        return;
      }

      setLoading(true);

      try {
        const { response, data } = await GalleryService.getArtworkForEdit(artworkSlug);

        if (!isMounted) {
          return;
        }

        if (response?.ok && data) {
          setArtworkData(data);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    loadArtwork();

    return () => {
      isMounted = false;
    };
  }, [artworkSlug, seededArtwork]);

  if (!seededArtwork) {
    return (
      <Navigate to="/inventory/available" replace/>
    );
  }

  if (loading) {
    return <Loader />;
  }

  if (!artworkData) {
    return <Navigate to="/inventory/available" replace/>;
  }

  return (
    <>
      <AddArtworkForm artworkData={artworkData} editMode/>
    </>
  );
}
